// and now for a bunch of image imports
import FullSewInImage from './images/FullSewIn.png';
import QuickWeaveImage from './images/QuickWeave.png';
import ClosureSewInImage from './images/ClosureSewIn.png';
import BoxBraidsImage from './images/BoxBraids.png';
import KnotlessBraidsImage from './images/KnotlessBraids.png';
import CrochetBraidsImage from './images/CrochetBraids.png';
import KidsBraidsImage from './images/KidsBraids1.png';
import CornrowsImage from './images/Cornrows.png';
import GoddessBraidsImage from './images/Goddess.png';
import FeedInBraidsImage from './images/Feed-in.png';
import SilkPressImage from './images/SilkPress.png';
import NaturalStyleImage from './images/NaturalStyle.png';
import FlexiRodsImage from './images/FlexiRods.png';
import HairTreatmentsImage from './images/HairTreatments.png';
import LaceSewInImage from './images/LaceSewIn.png';
import NaturalCutImage from './images/NaturalCut.png';
import NaturalTwistsImage from './images/NaturalTwists.png';
import WashAndGoImage from './images/WashAndGo.png';
import BlowoutImage from './images/Blowout_Style.png';
import ColorImage from './images/Color.png'; // not to be confused with black and white
import TwistOutImage from './images/TwistOut.png';

export const SEARCH_PARAM_RESET_CODE = '-';

export const SEARCH_ONE_CLICK_KEYWORD_FLAG_NAME = 'client_oneclickkeyword_flag_20200205';
export const SEARCH_ONE_CLICK_KEYWORD_AB_TEST_NAME = 'client_oneclickkeyword_20200205';
export const SEARCH_ONE_CLICK_KEYWORD_AB_TEST_PERCENT_FLAG_NAME = 'client_oneclickkeyword_override_percent_20200205';

export const SEARCH_HAIRTYPE_LIST = [
  'Curly',
  'Kinky',
  'Natural',
  'Short',
  'Medium',
  'Long',
  'Bob',
  'Layers',
  'Straight',
  'Thick',
];
export const SEARCH_HAIRTYPE_AB_SPECIALS = /^(wom[ae]n[s]? )?(hair\s?)?cut$/i;

export const SEARCH_SENTIMENT_SURVEY_FLAG_NAME = 'client_search_sentimentsurvey_202000306';

export const EARNED_PRO_BOOST_FLAG_NAME = 'client_search_newproboost_fly_2137';

// ATL-2007
export const SEARCH_VIRTUAL_APPT_NATIONAL_SEARCH_FLAG_NAME = 'client_search_virtual_appt_national_20200414';

// FLY-2796, 2791, 2786, 2945
export const NEW_PRO_SEARCH_BOOST_FLAG_NAME = 'pro_newpro_searchboost_fly2945_20210616';

// ATL-3768
// ATL-3768, 3833
export const SEARCH_SERVICES_CLIP_IMAGES_TEST_NAME = 'client_search_clipimagesservicewithphotoranking_atl3833_20210621';
export const SEARCH_SERVICES_CLIP_IMAGES_TEST_PERCENT = 0.5;

export const SEARCH_SERVICES_CLIP_IMAGES_NO_RANK_TEST_NAME = 'client_search_clipimagesservicewithoutphotoranking_atl3833_20210621';
export const SEARCH_SERVICES_CLIP_IMAGES_NO_RANK_TEST_PERCENT = 0.5;

// ATL-3860
export const SEARCH_PROS_WITH_AVAILABILITY_FILTER_TEST_NAME = 'client_search_filterproswithavailability_atl3860_20210805';
export const SEARCH_PROS_WITH_AVAILABILITY_FILTER_TEST_PERCENT = 0.5;

// ATL-3958
export const SEARCH_TAILORED_UX_TEST_NAME = 'client_search_tailoredux_atl3958_20210831';
export const SEARCH_TAILORED_UX_TEST_PERCENT = 0.5;

// ATL-3989
export const SEARCH_AUTOFILL_UPDATED_SUGGESTIONS_KEY = 'client_search_updatedautofillsuggestions_list_atl3989_20210901';
export const SEARCH_AUTOFILL_UPDATED_SUGGESTIONS_PERCENT = 0.5;

// ATL- 4107
export const SEARCH_V4_TEST_NAME = 'client_search_v4_atl4107_atl4221_20220210';
export const SEARCH_V4_TEST_PERCENT = 0.5;

// DP-84
export const SEARCH_TERM_MATCHING_TEST_NAME = 'client_search_term_matching_dp84_20220725';
export const SEARCH_TERM_MATCHING_TEST_PERCENT = 0.5;

// DP-109
export const SEARCH_PAYMENTS_ADOPTER_TEST_NAME = 'search_payments_adopters_filter_dp109_20221011';
export const SEARCH_PAYMENTS_ADOPTER_TEST_PERCENT = 0.3;

const weavesImage = require('./images/searchbanner_weaves.jpg');
const silkPressImage = require('./images/searchbanner_silkpress.jpg');
const braidsImage = require('./images/searchbanner_braids.jpg');
const naturalHairImage = require('./images/searchbanner_naturalhair.jpg');

export type SearchRefinementOption = {
  label: string;
  query?: string;
  iconUrl?: string;
  // bannerUrl?: string;
};

export type TailoredUXConfig = {
  image: string;
  promoText?: string;
  searchKey: string;
  subCategories: Array<SearchRefinementOption>,
};
type TailoredUXConfigPair = [RegExp, TailoredUXConfig];

const NATURAL_HAIR_REGEX = /natural|wash ?(and|&) ?go|treatments?|color|blowout ?(and|&) ?style|twists?|silk ?press/i;
const BRAIDS_REGEX = /braids?|cornrows?/i;
const WEAVES_REGEX = /weaves?|sew[ -]?ins?/i;

export const SEARCH_TAILORED_UX_CATEGORIES = [
  [
    /silk ?press/i,
    {
      image: silkPressImage,
      promoText: 'Discover & book\nsilk press specialists\non StyleSeat',
      subCategories: [
        {
          label: 'Silk Press', query: 'silk press', iconUrl: SilkPressImage,
        },
        {
          label: 'Natural Style', query: 'natural style', iconUrl: NaturalStyleImage,
        },
        {
          label: 'Natural Twists', query: 'natural twists', iconUrl: NaturalTwistsImage,
        },
        {
          label: 'Color', query: 'color', iconUrl: ColorImage,
        },
        {
          label: 'Twist Out', query: 'twist out', iconUrl: TwistOutImage,
        },
        {
          label: 'Blowout & Style', query: 'blowout and style', iconUrl: BlowoutImage,
        },
        {
          label: 'Hair Treatments', query: 'hair treatments', iconUrl: HairTreatmentsImage,
        },
        {
          label: 'Natural Haircut', query: 'natural haircut', iconUrl: NaturalCutImage,
        },
        {
          label: 'Natural Flexi Rods', query: 'natural flexi rods', iconUrl: FlexiRodsImage,
        },
        {
          label: 'Wash & Go', query: 'wash and go', iconUrl: WashAndGoImage,
        },
      ],
      searchKey: 'silk_press',
    },
  ] as TailoredUXConfigPair,
  [
    BRAIDS_REGEX,
    {
      image: braidsImage,
      promoText: 'Discover & book\nexpert braiders\non StyleSeat',
      subCategories: [
        {
          label: 'Knotless', query: 'knotless braids', iconUrl: KnotlessBraidsImage,
        },
        {
          label: 'Box', query: 'box braids', iconUrl: BoxBraidsImage,
        },
        {
          label: 'Crochet', query: 'crochet braids', iconUrl: CrochetBraidsImage,
        },
        {
          label: 'Feed In', query: 'feed in braids', iconUrl: FeedInBraidsImage,
        },
        {
          label: 'Cornrows', query: 'cornrows', iconUrl: CornrowsImage,
        },
        {
          label: 'Goddess', query: 'goddess braids', iconUrl: GoddessBraidsImage,
        },
        {
          label: "Kid's", query: "kid's braids", iconUrl: KidsBraidsImage,
        },
      ],
      searchKey: 'braids',
    },
  ] as TailoredUXConfigPair,
  [
    WEAVES_REGEX,
    {
      image: weavesImage,
      promoText: 'Discover & book\nweave specialists\non StyleSeat',
      subCategories: [
        {
          label: 'Full Sew In', query: 'full sew in', iconUrl: FullSewInImage,
        },
        {
          label: 'Quick Weave', query: 'quick weave', iconUrl: QuickWeaveImage,
        },
        {
          label: 'Lace Closure Sew In', query: 'lace closure sew in', iconUrl: LaceSewInImage,
        },
        {
          label: 'Closure Sew In', query: 'closure sew in', iconUrl: ClosureSewInImage,
        },
      ],
      searchKey: 'weaves',
    },
  ] as TailoredUXConfigPair,
  [
    NATURAL_HAIR_REGEX,
    {
      image: naturalHairImage,
      promoText: 'Discover & book\nnatural hair experts\non StyleSeat',
      subCategories: [
        {
          label: 'Silk Press', query: 'silk press', iconUrl: SilkPressImage,
        },
        {
          label: 'Natural Style', query: 'natural style', iconUrl: NaturalStyleImage,
        },
        {
          label: 'Natural Twists', query: 'natural twists', iconUrl: NaturalTwistsImage,
        },
        {
          label: 'Color', query: 'color', iconUrl: ColorImage,
        },
        {
          label: 'Twist Out', query: 'twist out', iconUrl: TwistOutImage,
        },
        {
          label: 'Blowout & Style', query: 'blowout and style', iconUrl: BlowoutImage,
        },
        {
          label: 'Hair Treatments', query: 'hair treatments', iconUrl: HairTreatmentsImage,
        },
        {
          label: 'Natural Haircut', query: 'natural haircut', iconUrl: NaturalCutImage,
        },
        {
          label: 'Natural Flexi Rods', query: 'natural flexi rods', iconUrl: FlexiRodsImage,
        },
        {
          label: 'Wash & Go', query: 'wash and go', iconUrl: WashAndGoImage,
        },
      ],
      searchKey: 'natural_hair',
    },
  ] as TailoredUXConfigPair,
];
